const IllustrationType = {
    DEFAULT: 'default',
    REGIONAL: 'regional',
};

export default IllustrationType;
